import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import fetchHelper from 'helpers/FetchHelper'

function getMyProfile(payload?: any, cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${BASE_API_LIVE_SWAP}/auth/me`, {
        method: 'GET',
      })
      .then(([resp, status]: any) => {
        if (status === 200) {
          if (cbs) cbs(resp.data)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('getMyProfile', error)
  }

  return null
}

export default getMyProfile
